var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4813 6.25L6.25 16.8V43.75H43.75V16.8L34.5187 6.25H15.4813ZM14.7719 3.125H35.2281C35.4505 3.12484 35.6704 3.17214 35.873 3.26376C36.0756 3.35537 36.2564 3.48918 36.4031 3.65625L46.4875 15.1844C46.7369 15.4689 46.8746 15.8342 46.875 16.2125V45.3125C46.875 45.7269 46.7104 46.1243 46.4174 46.4174C46.1243 46.7104 45.7269 46.875 45.3125 46.875H4.6875C4.2731 46.875 3.87567 46.7104 3.58265 46.4174C3.28962 46.1243 3.125 45.7269 3.125 45.3125V16.2125C3.12468 15.8331 3.26242 15.4666 3.5125 15.1813L13.5938 3.6625C13.7403 3.4939 13.9213 3.35868 14.1245 3.26596C14.3277 3.17324 14.5485 3.12517 14.7719 3.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.125 15.625H46.875V18.75H3.125V15.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.875 16.0094V31.25H28.125V16.0094L25.6875 6.25H24.3125L21.875 16.0094ZM21.875 3.125H28.125L31.25 15.625V32.8125C31.25 33.2269 31.0854 33.6243 30.7924 33.9174C30.4993 34.2104 30.1019 34.375 29.6875 34.375H20.3125C19.8981 34.375 19.5007 34.2104 19.2076 33.9174C18.9146 33.6243 18.75 33.2269 18.75 32.8125V15.625L21.875 3.125Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSvgrepoCom1);
export default __webpack_public_path__ + "static/media/box-svgrepo-com 1.16c18426256435072f17b23bce1a7c28.svg";
export { ForwardRef as ReactComponent };